import { ModuleProvider, useModule } from '#providers'
import { ModuleData } from '#providers/moduleProvider'
import { DebtItem } from './Components/debtItem'
import { DebtOverviewModuleState } from './types/debtOverviewApi.types'

interface DebtOverviewModuleConfig {
	clientName?: string
	regionId: string
}

export type DebtOverviewModuleData = ModuleData<
	DebtOverviewModuleState,
	DebtItem[],
	DebtOverviewModuleConfig>
	
export const DebtOverviewModuleProvider: typeof ModuleProvider<DebtOverviewModuleData> =
	ModuleProvider

export const useDebtOverviewModule: typeof useModule<DebtOverviewModuleData> =
	useModule